import { EditMode } from "PFApp/booking/types/edit_mode";

export const isEditModeSelectOrDraft = (editMode: EditMode) =>
  [EditMode.Select, EditMode.DraftBulkOperation].includes(editMode);
